import { createFileRoute, Link } from "@tanstack/react-router";
import { TOOLS } from "@/lib/tools-config";
import { breadcrumbLd, itemListLd, SITE_OG_IMAGE } from "@/lib/seo";

const DESC =
  "Free car, towing and EV calculators: fuel cost, MPG, trip cost, truck payload, trailer weight distribution and EV charging time & cost. No sign-up, instant results.";

export const Route = createFileRoute("/tools/")({
  head: () => ({
    meta: [
      { title: "Free Car & Fuel Calculators | AutoSpecData" },
      { name: "description", content: DESC },
      { property: "og:title", content: "Free Car & Fuel Calculators" },
      { property: "og:description", content: DESC },
      { property: "og:url", content: "https://autospecdata.com/tools" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:image", content: SITE_OG_IMAGE },
      { name: "twitter:image", content: SITE_OG_IMAGE },
    ],
    links: [{ rel: "canonical", href: "https://autospecdata.com/tools" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          itemListLd(
            "Car calculators",
            TOOLS.map((t) => ({ name: t.name, path: `/tools/${t.slug}` })),
          ),
        ),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify(
          breadcrumbLd([
            { name: "Home", path: "/" },
            { name: "Tools", path: "/tools" },
          ]),
        ),
      },
    ],
  }),
  component: ToolsIndex,
});

function ToolsIndex() {
  return (
    <div>
      <nav className="mx-auto max-w-4xl px-4 sm:px-6 pt-4 text-sm text-muted-foreground">
        <Link to="/" className="hover:text-foreground">
          Home
        </Link>
        <span className="mx-2">/</span>
        <span className="text-foreground">Tools</span>
      </nav>
      <section className="border-b border-border bg-gradient-to-b from-secondary/40 to-background">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 py-8">
          <h1 className="text-3xl sm:text-4xl font-bold text-foreground">
            Free Car & Fuel Calculators
          </h1>
          <p data-quick-answer className="mt-4 max-w-3xl text-base leading-relaxed text-foreground">
            {DESC}
          </p>
          <Link
            to="/search"
            search={{ q: "", make: "", model: "", year: undefined, type: "", page: 1 }}
            className="cta-gold mt-6"
          >
            Find your vehicle
          </Link>
        </div>
      </section>
      <section className="mx-auto max-w-4xl px-4 sm:px-6 py-8 grid gap-4 sm:grid-cols-3">
        {TOOLS.map((t) => (
          <Link
            key={t.slug}
            to="/tools/$slug"
            params={{ slug: t.slug }}
            className="rounded-lg border border-border bg-card p-5 transition-colors hover:border-primary"
          >
            <h2 className="font-bold text-foreground">{t.name}</h2>
            <p className="mt-1 text-sm text-muted-foreground">{t.description}</p>
          </Link>
        ))}
      </section>
    </div>
  );
}
